export const PENDING_PHONE_NUMBERS_COOKIE_KEY = 'pending_phone_numbers';